declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../services/hcp.service';


import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIvfPlanTemplateRequest } from '../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../models/actor/actor';
import { ActorService } from '../../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../models/master/mastermodel';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbaddactivitytemplate',
  templateUrl: './addactivitytemplate.modal.html',
  styleUrls: ['./addactivitytemplate.modal.scss']
})

export class NgbAddactivitytemplateModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  DOB: NgbDateStruct;
  DateOfBirth: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  public isRequesting: boolean = false;
  
  CurrentSaveIvfPlanTemplateRequest: SaveIvfPlanTemplateRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {

    this.CurrentSaveIvfPlanTemplateRequest = new SaveIvfPlanTemplateRequest();
    this.CurrentSaveIvfPlanTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;


  }

  onSubmit() {
     //alert("On Submit");
    //this.CurrentSaveIvfPlanTemplateRequest.CycleType = "";
    //this.CurrentSaveIvfPlanTemplateRequest.Protocol = "";
    this.CurrentSaveIvfPlanTemplateRequest.TemplateCode = 1;

    this.CurrentSaveIvfPlanTemplateRequest.ConditionalOperator = 10;

    this.actorservice.SaveIvfPlanTemplate(this.CurrentSaveIvfPlanTemplateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
           
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }






 




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
